import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["error", "className", "title", "help", "caption", "required", "placeholder", "defaultValue", "disabled", "subTitle", "name", "visible"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { usePreventContextMenu } from "@/hooks";
import styles from "@/styles/Form.module.scss";
import classnames from "classnames";
import { forwardRef } from "react";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const TSTextAreaField = /*#__PURE__*/forwardRef((props, ref) => {
  const [on, off] = usePreventContextMenu();
  const {
      error,
      className,
      title,
      help,
      caption,
      required,
      placeholder,
      defaultValue,
      disabled,
      subTitle,
      name,
      visible
    } = props,
    _props = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsxs("div", {
    className: `${styles.inputField} ${styles.tsInputField} `,
    style: visible ? {} : {
      display: "none"
    },
    children: [title && /*#__PURE__*/_jsxs("legend", {
      className: classnames(`${styles.formTitle} ${styles.formTitleTS}`, {
        [styles.required]: required
      }),
      children: [subTitle, ".", title]
    }), help && /*#__PURE__*/_jsx("span", {
      className: `${styles.help} ${styles.small}`,
      children: help
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.commentArea,
      children: [/*#__PURE__*/_jsx("textarea", _objectSpread({
        ref: ref,
        name: name,
        placeholder: placeholder,
        className: classnames(styles.textInput, className),
        defaultValue: defaultValue,
        required: required,
        disabled: disabled,
        onFocus: off,
        onBlur: on
      }, props)), caption && /*#__PURE__*/_jsx("p", {
        className: styles.textInputCaption,
        children: caption
      })]
    })]
  });
});
TSTextAreaField.displayName = "TSTextAreaField";
export default TSTextAreaField;